<ng-container>
  <div class="forge-loader-overlay" *ngIf="isLoading">
    <img src="/assets/images/Building.gif" title="" />
  </div>

  <!-- Modern Top Navigation -->
  <nav class="modern-navbar">
    <!-- Left Section: Logo & Navigation -->
    <div class="navbar-left">
      <!-- Logo -->
      <div class="navbar-logo">
        <a class="logo-link" [routerLink]="homePageUrl">
          <img *ngIf="selectedOrg?.orgLogo"
            src="https://cbuildfiles.blob.core.windows.net/organizationimages/common/2025-08-27/ca519231-848e-4765-8bc4-c928d8aa82ceapcrda-Image.jpg"
            height="40" class="logo-image" />
          <img *ngIf="!selectedOrg?.orgLogo"
            src="https://cbuildfiles.blob.core.windows.net/organizationimages/common/2025-08-27/ca519231-848e-4765-8bc4-c928d8aa82ceapcrda-Image.jpg"
            height="40" class="logo-image" />
        </a>
      </div>

      <!-- Navigation Menu -->
      <div class="navbar-menu" *ngIf="isAuthenticated">
        <a class="nav-link" [routerLink]="['/dashboard']" routerLinkActive="active" title="Dashboard">
          <span class="nav-icon">📊</span>
          <span class="nav-text">Dashboard</span>
        </a>
        <a class="nav-link" [routerLink]="['/op-maintenance']" routerLinkActive="active"
          title="Operations & Maintenance">
          <span class="nav-icon">🔧</span>
          <span class="nav-text">O&M</span>
        </a>
        <a class="nav-link" [routerLink]="['/bms']" routerLinkActive="active" title="Building Management System">
          <span class="nav-icon">🏢</span>
          <span class="nav-text">BMS</span>
        </a>
        <!-- <a class="nav-link" [routerLink]="['/work-space']" routerLinkActive="active" title="Work Space">
          <span class="nav-icon">💼</span>
          <span class="nav-text">Work Space</span>
        </a> -->
      </div>
    </div>

    <!-- Right Section: Controls & Profile -->
    <div class="navbar-right">
      <!-- Organization Switch -->
      <div class="nav-control" *ngIf="hasMultipleOrg && selectedOrg">
        <button class="org-switch-btn" (click)="navigateToSelectOrg()">
          <img *ngIf="selectedOrg.orgLogo" [src]="selectedOrg.orgLogo" class="org-logo" />
          <span class="org-icon" *ngIf="!selectedOrg.orgLogo">🏢</span>
          <span class="org-name">{{ selectedOrg.orgName }}</span>
          <span class="dropdown-arrow">▼</span>
        </button>
      </div>

      <!-- Action Buttons -->
      <div class="nav-control">
        <a class="nav-action-btn" [routerLink]="homePageUrl" title="Dashboard" routerLinkActive="active">
          <span class="action-icon">🏠</span>
        </a>
      </div>

      <!-- Notifications -->
      <div class="nav-control">
        <cs-notifications></cs-notifications>
      </div>

      <!-- Separator -->
      <div class="nav-separator"></div>

      <!-- Profile Dropdown -->
      <div class="nav-control">
        <cs-nav-profile-dropdown [userInfo]="userInfo" (propertyFilter)="applyPropertyFilter($event)">
        </cs-nav-profile-dropdown>
      </div>
    </div>
  </nav>

  <cs-web-loader></cs-web-loader>
</ng-container>
